import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";
import {
  deleteReport,
  deleteReportById,
  selectReportForDeletion,
  selectState,
  setDeleteReportModalOpen,
} from "../reports.slice";
import { useEffect } from "react";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteReportModal = (
  { setClickOutsideActive }: IProps
) => {
  const { deleteReportModalOpen } = useSelector(selectState);
  const report = useSelector(selectReportForDeletion);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (deleteReportModalOpen) {
      setClickOutsideActive(false);
    }
  }, [deleteReportModalOpen, setClickOutsideActive])

  const close = () => {
    setClickOutsideActive(true);
    dispatch(setDeleteReportModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      if (report) {
        await dispatch(deleteReport(report.reportId));
        dispatch(deleteReportById(report.reportId));
        toast.success("Uspešno izbrisan izveštaj.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteReportModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje izveštaja"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da izbrišete dati izveštaj?
        <br />
        <br />
      </p>
    </Modal>
  );
};

export default DeleteReportModal;
